// src/config.js
const env = {
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'not found',
    frontendUrl: process.env.REACT_APP_FRONTEND_URL || 'not found',
    teste: process.env.REACT_APP_API_KEY || 'not found',
};

// console.log('WILLIANS:', process.env.REACT_APP_FRONTEND_URL);

export default env;